import React, { useState, useEffect } from "react";
import 'react-phone-number-input/style.css';
import { BrowserView, isMobile } from "react-device-detect";
import Panier from "./panier/Panier";
import UserOrders from "./orders/Orders";
import InfoPerso from "./userinfo/UserInfos";
import Messagerie from "./messagerie/Messagerie";
import Sales from "./sales/Sales";
import {UserContext } from "../../AppContextProvider";
import { useContext } from "react";
import {useFetch} from "../api/FetchApiData";
import { useNavigate, useParams } from "react-router-dom";
import Partners from "./partners/Partners";
import Partner from "./partners/Partner";
import Delivers from "./delivers/Delivers";
import Deliver from "./delivers/Deliver";
import Payments from "./payments/Payments";
import Users from "./users/Users";
import TrackingMap from "../map/tracking/TrackingMap";
import orders_icon from './icons/orders.png';
import messaging_icon from './icons/messaging.png';
import sales_icon from './icons/sales.png';
import delivery_icon from './icons/delivery.png';
import payments_icon from './icons/payments.svg';
import panier_icon from '../icons/panier.png';
import logout_icon from '../icons/logout.png';
import Conversations from "./messagerie/Conversations";

if (isMobile)
    import('./user_mob.css').then(() => {});
else
    import('./user.css').then(() => {});


export function BrowserUserMenu({close=()=>{}})
{
    const [UserState, setUserState] = useContext(UserContext);
    const fetchData = useFetch();
    const navigator = useNavigate();

    const LogOut = ()=>
    {
        fetchData.LogOut(UserState,setUserState);
    }

    const AdMenu=(close)=>
    {
        if(UserState.is_staff)
        {
            return(
                <>
                { /*
                    <label onClick={e=>{navigator("/user/conversations/all/");close();}}>Messagerie
                        <div className="menu-icon">
                            <span className="menu-notification" style={{backgroundColor:'blue'}}>
                                {UserState.messages_counter}     
                            </span>
                            <img style={{width:'25px',verticalAlign:'middle'}} src={messaging_icon} className="icon" />
                        </div>
                    </label>
                    */
                }
                <label onClick={e=>{navigator("/user/sales/");close();}}>Ventes 
                    <div className="menu-icon">
                        <span className="menu-notification" style={{backgroundColor:'gray', color:'white'}}>
                            {UserState.sales_counter}
                        </span>
                        <img style={{width:'25px',verticalAlign:'middle'}} src={sales_icon} className="icon" />
                    </div>
                </label>
                <label onClick={e=>{navigator("/user/delivers/");close();}}>Livreurs 
                    <div className="menu-icon">
                        <img style={{width:'25px',verticalAlign:'middle'}} src={delivery_icon} className="icon" />
                    </div>
                </label>
                <label onClick={e=>{navigator("/user/payments/");close();}}>Paiements 
                    <div className="menu-icon">
                        <span className="menu-notification" style={{backgroundColor:'gray', color:'white'}}>
                            {UserState.payments_counter}
                        </span>
                        <img style={{width:'25px',verticalAlign:'middle'}} src={payments_icon} className="icon" />
                    </div>
                </label>
                <label onClick={e=>{navigator("/user/partners/");close()}}>Partenaires
                    {
                        /*
                        <div className="menu-icon">
                        <img style={{width:'25px',verticalAlign:'middle'}} src={partners_icon} className="icon" />
                        </div>
                        */
                    }
                </label>
                <label onClick={e=>{navigator("/user/users/");close();}}>Utilisateurs 
                {
                        /*
                    <div className="menu-icon">
                        <img style={{width:'25px',verticalAlign:'middle'}} src={clients_icon} className="icon" />
                    </div>
                    */
                }
                </label>
                </>
            );
        }
        else if(UserState.is_partner && UserState.is_deliver)
        {
            return(
                <>
                    <label onClick={e=>{navigator("/user/sales/");close();}}>Mes Colis 
                        <div className="menu-icon">
                            <span className="menu-notification" style={{backgroundColor:'blue', color:'white'}}>
                                {UserState.sales_counter}
                            </span>
                            <img style={{width:'25px',verticalAlign:'middle'}} src={orders_icon} className="icon" />
                        </div>
                    </label>
                    <label onClick={e=>{navigator("/user/sales/");close();}}>Mes Livraisons
                            <div className="menu-icon">
                                <span className="menu-notification" style={{backgroundColor:'blue', color:'white'}}>
                                    {UserState.sales_counter}
                                </span>
                                <img style={{width:'25px',verticalAlign:'middle'}} src={delivery_icon} className="icon" />
                            </div>
                    </label>
                    <label onClick={e=>{navigator("/user/payments/");close();}}>Mes Paiements 
                        <div className="menu-icon">
                            <span className="menu-notification" style={{backgroundColor:'blue', color:'white'}}>
                                    {UserState.payments_counter}
                                </span>
                            <img style={{width:'25px',verticalAlign:'middle'}} src={payments_icon} className="icon" />
                        </div>
                    </label>
                </>
            )
        }
        else if(UserState.is_partner)
        {
            return(
                <> 
                    <label onClick={e=>{navigator("/user/partner/myshop/");close();}}>Ma Boutique 
                        <div className="menu-icon">
                            <span className="menu-notification" style={{backgroundColor:'blue', color:'white'}}>
                                {UserState.sales_counter}
                            </span>
                            <img style={{width:'25px',verticalAlign:'middle'}} src={orders_icon} className="icon" />
                        </div>
                    </label>
                    <label onClick={e=>{navigator("/user/sales/");close();}}>Mes Colis 
                        <div className="menu-icon">
                            <span className="menu-notification" style={{backgroundColor:'blue', color:'white'}}>
                                {UserState.sales_counter}
                            </span>
                            <img style={{width:'25px',verticalAlign:'middle'}} src={sales_icon} className="icon" />
                        </div>
                    </label>
                    <label onClick={e=>{navigator("/user/payments/");close();}}>Mes Paiements 
                        <div className="menu-icon">
                            <span className="menu-notification" style={{backgroundColor:'blue', color:'white'}}>
                                    {UserState.payments_counter}
                                </span>
                            <img style={{width:'25px',verticalAlign:'middle'}} src={payments_icon} className="icon" />
                        </div>
                    </label>
                </>
            );
        }
        else if(UserState.is_deliver)
            {
                return(
                    <>
                        <label onClick={e=>{navigator("/user/deliver/mydeliver/");close();}}>Mon Enseigne
                            <div className="menu-icon">
                                <span className="menu-notification" style={{backgroundColor:'blue', color:'white'}}>
                                    {UserState.sales_counter}
                                </span>
                                <img style={{width:'25px',verticalAlign:'middle'}} src={orders_icon} className="icon" />
                            </div>
                        </label>    
                        <label onClick={e=>{navigator("/user/sales/");close();}}>Mes Livraisons
                            <div className="menu-icon">
                                <span className="menu-notification" style={{backgroundColor:'blue', color:'white'}}>
                                    {UserState.sales_counter}
                                </span>
                                <img style={{width:'25px',verticalAlign:'middle'}} src={delivery_icon} className="icon" />
                            </div>
                        </label>
                        <label onClick={e=>{navigator("/user/payments/all/");close();}}>Mes Paiements 
                            <div className="menu-icon">
                                <span className="menu-notification" style={{backgroundColor:'blue', color:'white'}}>
                                    {UserState.payments_counter}
                                </span>
                                <img style={{width:'25px',verticalAlign:'middle'}} src={payments_icon} className="icon" />
                            </div>
                        </label>
                    </>
                );
        }
    }   
    
    
    return(
        <div id="Browser-Menu" style={{display:'inline-block'}} >
            <div className="menu-content" style={{display:'inline-block'}}>
                <label onClick={e=>{navigator("/user/infos/");close();}}>Informations personnelles</label>
                <label onClick={e=>{navigator("/user/orders/");close();}}>Mes Commandes
                    <div className="menu-icon">
                        <span className="menu-notification" style={{backgroundColor:'gray'}}>
                            {UserState.orders_counter}
                        </span>
                        <img style={{width:'25px',verticalAlign:'middle'}} src={orders_icon} className="icon" />
                    </div>
                </label>
                <label onClick={e=>{navigator('/user/panier/');close();}}>Panier 
                    <div className="menu-icon">
                        <span className="menu-notification" style={{backgroundColor:'orangered'}}>
                            {UserState.panier.articles.length}
                        </span>
                        <img style={{width:'25px',verticalAlign:'middle'}} src={panier_icon} className="icon" />
                    </div>
                </label>
                {AdMenu(()=>{close();})}            
                <label onClick={e=>{LogOut();close();}}>Deconnexion
                    <div className="menu-icon" style={{marginTop:'-5px'}}>
                        <img style={{width:'25px',verticalAlign:'middle'}} src={logout_icon} className="icon" />
                    </div>
                </label>
            </div>          
        </div>
    );
}


export default function User()
{
    const [UserState, setUserState] = useContext(UserContext);
    const navigator = useNavigate();
    const fetchData = useFetch();
    const {menu, param} = useParams();
    const [User,setUser] = useState({address:{country:'Comores'},locations:[],name:"",email:'',orders:[],panier:{articles:[]},messagerie:[],phone:''});

     
    useEffect(()=>{
        if(!UserState.auth)
            navigator('/');
        fetchData.GetData('user/').then((result)=>{
            if(result.result)
            {
                setUser({...result.user});
            }
        }).catch((error)=>{
            })
    },[]);
     
    useEffect(()=>{
        if(!UserState.auth)
            navigator('/');
    },[UserState.auth])

    const LogOut = ()=>
    {
        fetchData.LogOut(UserState,setUserState);
    }

    const ShowContent=()=>
    {
        if(menu==="infos")
        {   return <InfoPerso setUser={setUser} User={User} />}
        else if(menu==="orders")
        {  return <UserOrders User={User} setUser={setUser} />}
        else if(menu==="panier" && User.panier.articles.length>0)
        {   return <Panier User={User} setUser={setUser} />}
        else if(menu==="panier" && User.panier.articles.length===0)
        {
            return <InfoPerso setUser={setUser} User={User} />;
        }
        else if(menu==="conversation")
        { 
            return <Messagerie User={User} setUser={User} con_number={param} />
        }
        /*
            else if(menu==="conversations")
            {
                return <Conversations />
            }
        */
        else if(menu==="sales")
        {
            return <Sales setUser={setUser} User={User} />
        }
        else if(menu==="partners")
        {
            return <Partners />
        }
        else if(menu==="tracking")
        {
            return <TrackingMap />
        }
        else if(menu==="delivers")
        {
            return <Delivers />
        }
        else if(menu==="payments")
        {
            return <Payments User={User} />
        }
        else if(menu==="partner")
        {
            return <Partner id={param} />
        }
        else if(menu==="deliver")
        {
            return <Deliver id={param} />
        }
        else if(menu==="users")
        {
            return <Users id={param} />
        }
        else if(menu==="conversations")
        {
            return <Conversations />
        }
        else if(menu==='deconnecter')
        {
            LogOut();
        }
        else
        {return <InfoPerso setUser={setUser} User={User} />;}
        
    }

    return(
        <div id="User">
            <BrowserView style={{display:'inline-block',width:'20%',verticalAlign:'Top'}}>
                <BrowserUserMenu />
            </BrowserView>
            <div id="User-Content">
                {ShowContent()}
            </div>
        </div>
    );
}